<template>
    <!-- 船期查询 -->
    <div class="page-container">
		<el-form :model="shipScheduleForm" ref="shipScheduleFormRef" class="form-panel" label-position="top">
			<el-row class="panel-top">
                <el-col>
                    <el-row type="flex" justify="start" align="middle" :gutter="10">
                        <el-col :span="6">
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="船名/航次:">
                                        <el-input size="mini"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item>
                                        <label slot="label" class="label_no"></label>
                                        <el-input size="mini"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="船公司:">
                                <el-input size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="装货港:">
                                <el-input size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="目的港:">
                                <el-input size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="start" align="middle" :gutter="10">
                        <el-col :span="6">
                            <el-form-item label="开航日期从:">
                                <el-date-picker
                                    style="width:100%;"
                                    align="right"
                                    type="date"
                                    size="mini"
                                    placeholder="选择日期"
                                    :picker-options="pickerOptions">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="开航日期到:">
                                <el-date-picker
                                    style="width:100%;"
                                    align="right"
                                    type="date"
                                    size="mini"
                                    placeholder="选择日期"
                                    :picker-options="pickerOptions">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item>
                                <label slot="label" class="label_no"></label>
                              <el-button class="el-button-search" type="primary" size="small" plain @click="queryForm" >查询</el-button>
                              <el-button type="info" size="small" plain @click="resetForm" >重置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="panel-top border-rang padding-rang">
                <el-col>
                    <el-row type="flex" justify="center" align="middle">
                        <el-col class="ship-title" :span="4">中/英文船名</el-col>
                        <el-col class="ship-title" :span="2">航次</el-col>
                        <el-col class="ship-title" :span="4">预抵/预离日期</el-col>
                        <el-col class="ship-title" :span="6">船公司</el-col>
                        <el-col class="ship-title" :span="3">船代公司</el-col>
                        <el-col class="ship-title" :span="2">作业区</el-col>
                        <el-col class="ship-title" :span="4">订舱截止日期</el-col>
                    </el-row>
                    <el-row class="ship-list" type="flex" justify="center" align="middle" v-for="(item,index) in shipScheduleList" :key="index">
                        <el-col :span="4" class="ship-list-item">
                            <el-row>
                                {{item.zh_name}}
                            </el-row>
                            <el-row>
                                {{item.en_name}}
                            </el-row>
                        </el-col>
                        <el-col :span="2" class="ship-list-item">
                            {{item.voyage}}
                        </el-col>
                        <el-col :span="4" class="ship-list-item">
                             <el-row>
                                预抵日期：{{item.arrivals}}
                            </el-row>
                            <el-row>
                                预离日期：{{item.predissociation}}
                            </el-row>
                        </el-col>
                        <el-col :span="6" class="ship-list-item">
                            {{item.shipping_company}}
                        </el-col>
                        <el-col :span="3" class="ship-list-item">
                            {{item.shipping_agency_company}}
                        </el-col>
                        <el-col :span="2" class="ship-list-item">
                            {{item.operation_area}}
                        </el-col>
                        <el-col :span="4" class="ship-list-item">
                            {{item.booking_deadline}}
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="panel-top">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="100"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="400">
                </el-pagination>
            </el-row>
		</el-form>
	</div>
</template>

<script>

export default {
    name: 'ShipSchedule',
    data() {
        return {
            shipScheduleForm: {},
            pickerOptions: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                    picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                    }
                }]
            },
            currentPage: 4,
            shipScheduleList: [
                {
                    zh_name: '大新9',
                    en_name: 'DA XIN 9',
                    voyage: 'B1825E',
                    arrivals: '2019-01-20',
                    predissociation: '2019-01-23',
                    shipping_company: '江苏中外运船务代理有限公司',
                    shipping_agency_company: '中集凯通江西九江分',
                    operation_area: '上海洋山',
                    booking_deadline: '2019-11-15 00:00'
                },
                {
                    zh_name: '长江之盛',
                    en_name: 'CHANG JIANG ZHI SHENG',
                    voyage: '0054S',
                    arrivals: '2019-01-20',
                    predissociation: '2019-01-24',
                    shipping_company: '江苏中外运船务代理有限公司',
                    shipping_agency_company: '青岛振华船代班轮部',
                    operation_area: '上海洋山',
                    booking_deadline: '2019-11-15 00:00'
                },
                {
                    zh_name: '锦源纽约',
                    en_name: 'JIN YUAN NIU YUE',
                    voyage: 'B1825E',
                    arrivals: '2019-01-20',
                    predissociation: '2019-01-25',
                    shipping_company: '江苏中外运船务代理有限公司',
                    shipping_agency_company: '中集凯通江西九江分',
                    operation_area: '上海洋山',
                    booking_deadline: '2019-11-15 00:00'
                }
            ]
        };
    },
    async created() {

    },
    mounted() {

    },
    methods: {
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        }
    }
};
</script>

<style scoped lang="scss">
    .ship-title {
        height: 30px;
        line-height: 30px;
        text-align: center;
        background-color: #ECF4FF;
        border-right: 1px solid #ffffff;
    }
    .ship-list {
        padding: 8px;
        background-color: #F9F9F9;
        border-bottom: 4px solid #ffffff;
    }
    .ship-list-item {
        text-align: center;
    }
</style>
